import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedBlobField, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getUsers } from 'app/modules/administration/user-management/user-management.reducer';
import { createEntity, getEntity, reset, updateEntity } from './user-extra.reducer';

export const UserExtraUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const users = useAppSelector(state => state.userManagement.users);
  const userExtraEntity = useAppSelector(state => state.userExtra.entity);
  const loading = useAppSelector(state => state.userExtra.loading);
  const updating = useAppSelector(state => state.userExtra.updating);
  const updateSuccess = useAppSelector(state => state.userExtra.updateSuccess);

  const handleClose = () => {
    navigate('/user-extra');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getUsers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }

    const entity = {
      ...userExtraEntity,
      ...values,
      user: users.find(it => it.id.toString() === values.user?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...userExtraEntity,
          user: userExtraEntity?.user?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="factcheckingApp.userExtra.home.createOrEditLabel" data-cy="UserExtraCreateUpdateHeading">
            <Translate contentKey="factcheckingApp.userExtra.home.createOrEditLabel">Create or edit a UserExtra</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="user-extra-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('factcheckingApp.userExtra.title')}
                id="user-extra-title"
                name="title"
                data-cy="title"
                type="text"
              />
              <ValidatedField
                label={translate('factcheckingApp.userExtra.title2')}
                id="user-extra-title2"
                name="title2"
                data-cy="title2"
                type="text"
              />
              <ValidatedField
                label={translate('factcheckingApp.userExtra.position')}
                id="user-extra-position"
                name="position"
                data-cy="position"
                type="text"
              />
              <ValidatedField
                label={translate('factcheckingApp.userExtra.note')}
                id="user-extra-note"
                name="note"
                data-cy="note"
                type="text"
              />
              <ValidatedBlobField
                label={translate('factcheckingApp.userExtra.signature')}
                id="user-extra-signature"
                name="signature"
                data-cy="signature"
                isImage
                accept="image/*"
              />
              <ValidatedField
                id="user-extra-user"
                name="user"
                data-cy="user"
                label={translate('factcheckingApp.userExtra.user')}
                type="select"
              >
                <option value="" key="0" />
                {users
                  ? users.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.login}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/user-extra" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default UserExtraUpdate;
